import { render, staticRenderFns } from "./StaffDescription.vue?vue&type=template&id=3a98a676&scoped=true"
import script from "./StaffDescription.vue?vue&type=script&lang=js"
export * from "./StaffDescription.vue?vue&type=script&lang=js"
import style0 from "./StaffDescription.vue?vue&type=style&index=0&id=3a98a676&prod&lang=scss"
import style1 from "./StaffDescription.vue?vue&type=style&index=1&id=3a98a676&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a98a676",
  null
  
)

export default component.exports